var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "header-popup" }, [
      _vm.dataDetail.trigger.type === "form"
        ? _c("img", {
            staticClass: "mr-2",
            attrs: {
              src: require("@/assets/automation/data_manager.svg"),
              width: "26",
              height: "26"
            }
          })
        : _vm.dataDetail.trigger.type === "event"
        ? _c("img", {
            staticClass: "mr-2",
            attrs: {
              src: require("@/assets/automation/event.svg"),
              width: "26",
              height: "26"
            }
          })
        : _vm.dataDetail.trigger.type === "function"
        ? _c("img", {
            staticClass: "mr-2",
            attrs: {
              src: require("@/assets/automation/function.svg"),
              width: "26",
              height: "26"
            }
          })
        : _vm.dataDetail.trigger.type === "job" ||
          _vm.dataDetail.trigger.type === "dedicated_job"
        ? _c("img", {
            staticClass: "mr-2",
            attrs: {
              src: require("@/assets/automation/job.svg"),
              width: "26",
              height: "26"
            }
          })
        : _c("img", {
            staticClass: "mr-2",
            attrs: {
              src: require("@/assets/automation/api.svg"),
              width: "26",
              height: "26"
            }
          }),
      _vm._v(" "),
      _c("div", { staticClass: "header-text" }, [
        _vm._v(_vm._s(_vm.dataDetail.name))
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "tabs" },
      _vm._l(_vm.tabs, function(tab) {
        return _c(
          "div",
          {
            key: tab.key,
            staticClass: "tab-list",
            class: {
              active: tab.key === _vm.tabSelected,
              disabled: !tab.active
            },
            on: {
              click: function($event) {
                _vm.handleClickTab(tab)
              }
            }
          },
          [_vm._v("\n      " + _vm._s(tab.label) + "\n    ")]
        )
      })
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "popup-content" },
      [
        _vm.tabSelected === "detail"
          ? _c("j-popup-detail-tab", {
              attrs: { "data-detail": _vm.dataDetail }
            })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ebe1de2e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ebe1de2e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/visual-programming/popup/jPopupDetailVp.vue
// module id = null
// module chunks = 